import { Box, SvgIcon } from '@mui/material';
import { useRecordContext, FieldProps } from 'react-admin';

export const IconField = (props: FieldProps & { iconMap: Record<string, typeof SvgIcon> }) => {

  const record = useRecordContext(props);
  const icon = record?.[props.source];
  if (!icon) return null;
  const Icon = props.iconMap[icon];
  if (!Icon) return null;
  return (
    <Box display="flex" alignItems="center">
      <Icon fontSize="small" />
    </Box>
  );

};
